import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberDetailsCommunicationHistoryToDosWidget as MemberDetailsCommunicationHistoryToDosWidgetView } from 'ui/views/widgets/memberDetailsCommunicationHistoryToDosWidget';
import { MemberDetailsCommunicationHistoryToDosWidgetService } from 'services/memberDetailsCommunicationHistoryToDosWidget';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import queryString from 'query-string';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsCommunicationHistoryToDosWidget } from 'ui/containers/MemberDetailsCommunicationHistoryToDosWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryToDosWidget propName='propValue'/>
 */
class _MemberDetailsCommunicationHistoryToDosWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.handleActionClick = this.handleActionClick.bind( this );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined
        };

         // Member Detail instance
         this.memberDetailsCommunicationHistoryToDosWidgetService = new MemberDetailsCommunicationHistoryToDosWidgetService();

         // start member detail data fetch
         this.fetchComponentData();
    }

    async fetchComponentData() {
        log.debug( 'MemberDetailsCommunicationHistoryToDosWidget.fetchComponentData()' );

        // cancel ongoing request
        this.memberDetailsCommunicationHistoryToDosWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsCommunicationHistoryToDosWidgetService.fetchComponentData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {} } = {} ) {
        log.debug( 'ToDosWidget.handleActionClick()' );
        if( 'column' === type && 'taskId' === value.name  ) {
            this.props.history.push( { pathname: DASHBOARD_SUB_ROUTES.TO_DO_DETAIL, search: queryString.stringify( {
                callId: item.id,
            }  ) } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsCommunicationHistoryToDosWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsCommunicationHistoryToDosWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberDetailsCommunicationHistoryToDosWidget.displayName = 'MemberDetailsCommunicationHistoryToDosWidget';

// set default props
_MemberDetailsCommunicationHistoryToDosWidget.defaultProps = {};

// prop types
_MemberDetailsCommunicationHistoryToDosWidget.propTypes = {};

export const MemberDetailsCommunicationHistoryToDosWidget = withRouter( _MemberDetailsCommunicationHistoryToDosWidget );

